import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoiceState {
  loading: boolean;
  fileBase64Content: string | null;
  error: string | null;
  open: boolean;
}

const initialState: InvoiceState = {
  loading: false,
  fileBase64Content: null,
  error: null,
  open: false,
};

const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {
    fetchInvoiceRequest: (state, action: PayloadAction<string>) => {
      state.loading = true;
      state.error = null;
    },
    fetchInvoiceSuccess: (
      state,
      action: PayloadAction<{ fileBase64Content: string }>
    ) => {
      state.loading = false;
      state.fileBase64Content = action?.payload?.fileBase64Content;

      state.open = true;
    },
    fetchInvoiceFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    closeInvoiceModal: (state) => {
      state.open = false;
      state.fileBase64Content = null;
    },
  },
});

// Actions
export const InvoiceActions = {
  fetchAll: createAction<{ orderId: string }>(`${invoiceSlice.name}/fetchAll`),

  fetchInvoiceRequest: invoiceSlice.actions.fetchInvoiceRequest,
  fetchInvoiceSuccess: invoiceSlice.actions.fetchInvoiceSuccess,
  fetchInvoiceFailure: invoiceSlice.actions.fetchInvoiceFailure,
  closeInvoiceModal: invoiceSlice.actions.closeInvoiceModal,
};

export default invoiceSlice.reducer;
